import { render, staticRenderFns } from "./BaseSummaryList.vue?vue&type=template&id=29aa8cd4&"
import script from "./BaseSummaryList.vue?vue&type=script&lang=js&"
export * from "./BaseSummaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports